import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { business } from '../data/content';
type CallButtonProps = {
  label?: string;
  size?: 'md' | 'lg';
  className?: string;
};
export function CallButton({
  label = 'Call for a Free Estimate',
  size = 'md',
  className = ''
}: CallButtonProps) {
  const sizing = size === 'lg' ? 'px-7 py-4 text-base md:text-lg' : 'px-5 py-3 text-sm';
  return <a href={business.phoneHref} className={`inline-flex items-center justify-center gap-2.5 whitespace-nowrap rounded-md bg-brick font-semibold text-white shadow-sm transition-[background-color,transform] duration-150 ease-out hover:bg-brick-dark active:scale-[0.98] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brick ${sizing} ${className}`} data-id="element-43" data-mp="369dnkicl9xbd">
      <PhoneIcon className={size === 'lg' ? 'h-5 w-5' : 'h-4 w-4'} aria-hidden="true" data-id="element-44" data-mp="ujthojwq9hyy" />
      {label}
    </a>;
}